import React from "react";
import { Box, Chip, LinearProgress, Stack, Typography } from "@mui/material";
import TipsAndUpdatesRoundedIcon from "@mui/icons-material/TipsAndUpdatesRounded";

export default function StepHeader({ steps, step, title, helper }) {
  const progress = ((step + 1) / steps.length) * 100;

  return (
    <Stack spacing={1.6}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        gap={1.2}
      >
        <Box>
          <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap" sx={{ mb: 0.8 }}>
            <Typography variant="h5" sx={{ fontWeight: 950, letterSpacing: -0.6 }}>
              {title || steps?.[step]?.label}
            </Typography>
            <Chip
              size="small"
              label={`Etapa ${step + 1} de ${steps.length}`}
              sx={{
                fontWeight: 900,
                bgcolor: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            />
          </Stack>
          <Typography sx={{ color: "rgba(255,255,255,0.64)", maxWidth: 760, lineHeight: 1.55 }}>
            {helper || "Tudo o que você preencher aqui impacta a vitrine e a venda do evento."}
          </Typography>
        </Box>

        <Chip
          icon={<TipsAndUpdatesRoundedIcon sx={{ fontSize: 18 }} />}
          label="Preencha com calma e clareza"
          sx={{
            fontWeight: 800,
            bgcolor: "rgba(109,255,178,0.1)",
            color: "#9dffc8",
            border: "1px solid rgba(109,255,178,0.2)",
          }}
        />
      </Stack>

      <Stack spacing={0.8}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 8,
            borderRadius: 2,
            bgcolor: "rgba(255,255,255,0.06)",
            "& .MuiLinearProgress-bar": {
              borderRadius: 2,
              background:
                "linear-gradient(90deg, rgba(0,225,255,0.95), rgba(109,255,178,0.95))",
            },
          }}
        />
        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
          Você está construindo a apresentação do evento etapa por etapa.
        </Typography>
      </Stack>
    </Stack>
  );
}
